<template>
  <div class="text-left">
    <span class="star-item h7" @click="$emit('setStar',starItem)" v-for="(starItem,index) in $GVAR.HotelStar.slice(2)" :key="index">{{starItem.name}}</span>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

    export default {
        name: 'ChooseStar',
      computed: {
        ...mapState(['userLoginMessage']),
      }
    }
</script>

<style lang="scss" scoped>
  .star-item {
    color: #000;
    display: inline-block;
    width:90px;
    padding-left: 5px;
    margin-bottom: 10px;
    cursor: pointer;
    &:hover{
      color: red;
    }
  }
</style>
